var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 192 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M0 22H64",
    stroke: "var(--stroke-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224803_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    opacity: 0.25,
    cx: 96,
    cy: 22,
    r: 16,
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.0007 17.3892C87.0582 17.3586 88.9049 19.6717 93.3357 21.1969C91.7037 18.0617 90.6267 14.3551 90.6762 10.72C87.3725 8.31725 83.6533 7.68622 83.4707 7.65647C82.9381 7.56978 82.4761 8.03132 82.5628 8.56431C82.5976 8.77783 83.4534 13.8233 87.0007 17.3892Z",
    fill: "#7A9D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6643 21.197C100.646 20.5147 102.586 19.5023 104.196 18.1322C104.822 17.598 105.029 17.3445 105.04 17.3474C108.553 13.784 109.403 8.77704 109.437 8.56436C109.524 8.03195 109.063 7.56983 108.529 7.65653C108.347 7.68627 104.628 8.31719 101.324 10.7197C101.375 14.2968 100.323 18.0105 98.6643 21.197Z",
    fill: "#7A9D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2944 12.0932C92.64 17.2298 95.2155 21.3342 95.3326 21.5184C95.6429 22.006 96.3566 22.0067 96.6674 21.5184C96.7846 21.3342 99.36 17.2298 99.7056 12.0932C99.7462 11.4901 99.7532 10.9406 99.7334 10.3825C99.5421 4.99577 96.7907 0.561959 96.6695 0.36937C96.3597 -0.123123 95.6404 -0.123123 95.3305 0.36937C95.2101 0.560641 92.4945 4.93713 92.2709 10.2754C92.2815 10.2754 92.2172 10.9448 92.2944 12.0932Z",
    fill: "#7A9D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.122 20.454C109.039 20.3938 107.727 19.4525 105.814 18.8037C103.64 20.8657 100.822 22.271 97.9927 23.0629C99.1738 23.5547 100.688 23.9941 102.328 23.9941C105.971 23.9941 108.995 21.8257 109.122 21.7334C109.556 21.4175 109.555 20.7693 109.122 20.454Z",
    fill: "#7A9D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.209 23.3312V26.209C95.209 26.6458 95.5632 27 96 27C96.4369 27 96.791 26.6458 96.791 26.209V23.3312C96.2779 23.5118 95.723 23.5121 95.209 23.3312Z",
    fill: "#7A9D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1858 18.8037C84.2736 19.4524 82.961 20.3938 82.8783 20.4539C82.4439 20.7699 82.4448 21.418 82.8783 21.7334C83.0053 21.8257 86.0287 23.9941 89.6718 23.9941C91.3121 23.9941 92.8264 23.5545 94.0076 23.0628C91.1789 22.2712 88.3603 20.8664 86.1858 18.8037Z",
    fill: "#7A9D6B"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M128 22H192",
    stroke: "var(--stroke-0, #7A9D6B)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionLabel);
export default __webpack_public_path__ + "static/media/section_label.4eec2383336365b97b48ad9b3e0f0155.svg";
export { ForwardRef as ReactComponent };